import { useState, MouseEvent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import Info from "@material-ui/icons/Info";
import Edit from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTableActionStyles } from "./styles";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Totem } from "../../../../../@types/totem";
import { CheckCircle, FileCopy, NotInterested } from "@material-ui/icons";
import TotemActiveToggle from "../../../components/active-toggle";
import TotemToken from "../../../components/token";
import Visibility from "@material-ui/icons/Visibility";

type Props = {
    totem: Totem;
}

export default function ListTableActions({ totem }: Props) {
    const { pathname } = useLocation();
    const { classes } = useTableActionStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} >
                <MoreVert />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/${totem.id}`}
                >
                    <Info htmlColor="#706E7A" />
                    Informações
                </MenuItem>
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/${totem.id}/editar`}
                >
                    <Edit htmlColor="#706E7A" />
                    Editar
                </MenuItem>
                <TotemToken
                    totem={totem}
                    buttonTrigger={
                        <MenuItem
                            onClick={handleClose}
                            className={classes.menuItem}
                        >
                            <Visibility htmlColor="#706E7A" />
                            Token
                        </MenuItem>
                    }
                />
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`${pathname}/${totem.id}/duplicar`}
                >
                    <FileCopy htmlColor="#706E7A" />
                    Duplicar
                </MenuItem>
                <TotemActiveToggle
                    totem={totem}
                    buttonTrigger={
                        <MenuItem
                            onClick={handleClose}
                            className={classes.menuItem}
                        >
                            {totem.ativo ? (
                                <NotInterested htmlColor="#706E7A" />
                            ) : (
                                <CheckCircle htmlColor="#706E7A" />
                            )}
                            {totem.ativo ? "Inativar" : "Ativar"}
                        </MenuItem>
                    }
                />
            </Menu>
        </>
    );
}
